export default __webpack_public_path__ + "static/media/login.1519ba58.jpg";